import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import SearchInputTrigger from '../SearchInputTrigger'
import DateInputValue from './DateInputValue'

const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  min-width: ${rem(300)};
  width: 100%;
`

const DateInputTrigger = styled(SearchInputTrigger)`
  display: flex;
  flex-direction: row;
  min-width: ${rem(300)};
  border: 1px solid ${props => props.theme.palette.neutral.five};
  height: ${rem(48)};
`

interface Props {
  onDateToggle: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
}

/**
 * UI to show I'm flexible box
 */
function AnytimeDateTrigger(props: Props) {
  const { className, onDateToggle } = props
  return (
    <InputContainer className={className}>
      <DateInputTrigger
        onClick={onDateToggle}
      >
        <DateInputValue label="When?" placeholder="Anytime" />
      </DateInputTrigger>
    </InputContainer>
  )
}

export default AnytimeDateTrigger
